module.exports = __webpack_public_path__ + "static/media/logo-text.af6fdf07.png";